import Vue from 'vue/dist/vue.esm';
import AnswerForm from 'components/bodoans/answer_form.vue';
import GameSelector from 'components/bodoans/game_selector.vue';
import axios from 'axios';

document.addEventListener('DOMContentLoaded', () => {
  const polls = JSON.parse(document.getElementById('bodoan-show').dataset.polls);
  const userId = document.getElementById('bodoan-show').dataset.userId;
  const nameUrl = document.getElementById('bodoan-show').dataset.nameUrl;
  new Vue({
    el: '#bodoan-show',
    components: { AnswerForm, GameSelector },
    data: {
      selectedPollId: null,
      games: [],
      page: 1,
      errorMessage: '',
      successMessage: '',
      submitting: false,
      infiniteId: +new Date(),
      polls: polls,
      nameUrl: nameUrl,
      answer: {
        xAccountId: ''
      }
    },
    computed: {
      userId: function () {
        return userId || null;
      },
      searchGamesPath: function () {
        return '/bodoans/games.json';
      },
      postAnswerPath: function () {
        return `/bodoans/${this.nameUrl}/answers`;
      },
      defaultFilterType: function () {
        return this.userId ? 'mygame' : 'all';
      }
    },
    created: function () {
      this.onSearch(this.defaultFilterType, null);
    },
    methods: {
      openSearchForm: function(poll) {
        this.selectedPollId = poll.id;
      },
      closeSearchForm: function() {
        this.selectedPollId = null;
      },
      addGame: function(game) {
        const poll = this.polls.find(poll => poll.id === this.selectedPollId);
        poll.answeredGames.push(game);
      },
      removeGame: function(game) {
        const poll = this.polls.find(poll => poll.id === this.selectedPollId);
        const gameIndex = poll.answeredGames.findIndex(answeredGame => answeredGame.id === game.id);
        poll.answeredGames.splice(gameIndex, 1);
      },
      infiniteLoad($state, filterType, freeword) {
        axios.get(this.searchGamesPath, {
          params: { filterType: filterType, freeword: freeword, page: this.page }
        }).then(({ data }) => {
          if (data.games.length) {
            this.page += 1;
            this.games.push(...data.games);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      },
      onSearch: function (filterType, freeword) {
        let self = this;
        self.searching = true;
        var params = { filterType: filterType, freeword: freeword };

        axios.get(self.searchGamesPath, { params: params }).then(function (response) {
          const data = response.data;
          self.games = [];
          self.games = data.games;
          self.page = 2;
          self.infiniteId++;
        });
      },
      putAnswerPath: function (poll) {
        return `/bodoans/${this.nameUrl}/answers/${poll.answerId}`;
      },
      onSubmit: async function() {
        const self = this;
        const errorMessages = [];
        self.submitting = true;
        self.successMessage = '';
        self.errorMessage = '';

        const targetPolls = self.polls.filter(poll => poll.answeredGames.length > 0);
        if (targetPolls.length === 0) {
          self.errorMessage = '１件以上のボードゲームを選択してください。';
          self.submitting = false;
          return;
        }
        // NOTE: カテゴリーごとに質問(bodoan_polls)レコードがあるので、それぞれに対して回答を送信する
        for (const poll of targetPolls) {
          try {
            await self.sendAnswer(poll);
          } catch (e) {
            errorMessages.push(e.message || e);
          }
        }

        if (errorMessages.length === 0) {
          self.successMessage = '回答しました。';
        } else {
          self.errorMessage = errorMessages.filter((message, index, self) => self.indexOf(message) === index).join('\n');
        }
        self.submitting = false;
      },
      sendAnswer: async function (poll) {
        const params = {
          poll_id: poll.id, game_ids: poll.answeredGames.map(game => game.id),
          x_account_id: this.answer.xAccountId, format: 'json'
        };

        let response = null;
        // NOTE: 回答済みの場合はPUT(updateアクション)、未回答の場合はPOST(createアクション)で実行する
        if (poll.answerId) {
          response = await axios.put(this.putAnswerPath(poll), params);
        } else {
          response = await axios.post(this.postAnswerPath, params);
        }

        const data = response.data;
        if (data.status === 'error') {
          throw new Error(data.message);
        }
        if (data.status === 'success') {
          poll.answerId = data.answerId;
        }
      },
    },
    template: `
      <div>
        <answer-form
          :polls='polls'
          :errorMessage='errorMessage'
          :successMessage='successMessage'
          :userId='userId'
          :answer='answer'
          :submitting='submitting'
          :nameUrl='nameUrl'
          @open-search-form='openSearchForm'
          @submit='onSubmit'
        >
        </answer-form>
        <game-selector
          :userId='userId'
          :defaultFilterType='defaultFilterType'
          :polls='polls'
          :selectedPollId='this.selectedPollId'
          :games='games'
          :infiniteId='infiniteId'
          @close-search-form='closeSearchForm'
          @add-game='addGame'
          @remove-game='removeGame'
          @search='onSearch'
          @infinite-load='infiniteLoad'
        >
        </game-selector>
      </div>
    `
  });
});
